import React from 'react';
import { FormSection } from '../../common/FormSection';
import { FormInput } from '../../common/FormInput';
import { FormTextarea } from '../../common/FormTextarea';
import { BehaviourSupportPlanData } from 'src/models/form-types';

interface StudentInfoSectionProps {
  formData: BehaviourSupportPlanData;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  className?: string;
}

export const StudentInfoSection: React.FC<StudentInfoSectionProps> = ({ 
  formData, 
  onChange, 
  className 
}) => {
  return (
    <FormSection title="Student Information" className={className}>
      <div className="form-row form-row--2-cols">
        <FormInput
          id="studentAge"
          name="studentAge"
          label="Age"
          value={formData.studentAge}
          onChange={onChange}
          width="half"
        />
        
        <FormInput
          id="yearLevel"
          name="yearLevel"
          label="Year level"
          value={formData.yearLevel}
          onChange={onChange}
          width="half"
        />
      </div>
      
      <FormTextarea
        id="strengths"
        name="strengths"
        label="Strengths and Interests"
        value={formData.strengths}
        onChange={onChange}
        rows={4}
      />
    </FormSection>
  );
};
